import { isArray, toNumber } from 'lodash';

import { FieldKeyMaybeStringRecord, FormField } from './types';

const FIELD_KEY = 'fieldKey';

export const coerceNumber = (val: any): number | Array<number> | any => {
  let shimmed;
  if (isArray(val)) {
    shimmed = val.map(coerceNumber);
    return shimmed;
  } else {
    shimmed = toNumber(val);
    return isNaN(shimmed) ? val : shimmed;
  }
};

export const findFormField = (fieldKey: string, formFields: Array<FormField>) =>
  formFields.find((field) => fieldKeyEquals(fieldKey)(field));

const fieldKeyEquals = (fieldKey: string) => (field: any) =>
  field && field[FIELD_KEY] === fieldKey;

export const pluckTruthyFieldKeys = (formFields: Array<FormField>) =>
  formFields
    .filter(itemHasFieldKey)
    .map((field) => field[FIELD_KEY])
    .filter(Boolean);

export const requiredOrFalse = (validation: any) => validation.required || false;
export const validateOrUndefined = (validation: any) => validation.validate || undefined;
export const fieldKeyOrNull = (prop: any) => prop.fieldKey || null;
export const initValueOrEmptyString = (prop: any) => prop.initValue ?? '';
export const optionsOrUndefined = (prop: any) => prop.options || undefined;

const itemHasFieldKey = (item: FieldKeyMaybeStringRecord) =>
  Boolean(item && item[FIELD_KEY]);
